export default {
  namespaced: true,

  state: {
    dataTable: null,
    fileExel: null,
    formType: null
  },

  getters: {},

  mutations: {
    setData(state, payload) {
      state.dataTable = payload
    },

    reset(state) {
      state.formType = null
      state.fileExel = null
      state.dataTable = null
    }
  }
}
